import { createAction } from "@reduxjs/toolkit";
import axios from 'apis';
import { asyncThunkWrapper } from "helpers/asyncThunkWrapper";

const attributes = ['id', 'email', 'updated_at', { sixth_prompts: ['id', 'text', 'title', 'updated_at'] }];

export const getSixthFlow = asyncThunkWrapper({ 
  model: 'sixthFlow', 
  action: 'getSixthFlow', 
  func: async () => {
    const params = { attributes };
    const response = await axios.get(`/sixth_flow`, { params });
      
    return response.data;
  } 
});
export const createSixthFlow = asyncThunkWrapper({ 
  model: 'sixthFlow', 
  action: 'createSixthFlow', 
  func: async (sixth_flow) => {
    const response = await axios.post(`/sixth_flow`, { sixth_flow, attributes });

    return response.data;
  } 
});
export const updateSixthFlow = asyncThunkWrapper({ 
  model: 'sixthFlow', 
  action: 'updateSixthFlow', 
  func: async (sixth_flow) => {
    const response = await axios.patch(`/sixth_flow`, { sixth_flow });

    return { status: response.status, sixth_flow };
  } 
});
export const deleteSixthFlow = asyncThunkWrapper({ 
  model: 'sixthFlow', 
  action: 'deleteSixthFlow', 
  func: async () => {
    const response = await axios.delete(`/sixth_flow`);
      
    return { status: response.status };
  } 
});
export const clearLocalActiveSixthFlow = createAction('sixthFlow/clearLocalActiveSixthFlow');